export function HuiTabPanel() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {},
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
               <div class="hui-tab-panel" role="tabpanel" tabindex="0" ng-transclude></div>
            `;
        }
    }
}
